import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useUser } from '../UserContext';
import '../Estoque/index.css';

const Estoque = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();
  const [products, setProducts] = useState([]);
  const [order, setOrder] = useState({});
  const [showModal, setShowModal] = useState(false); // Controla a exibição do modal
  const [orderArray, setOrderArray] = useState([]); // Armazena os itens confirmados
  const [dataCadastro, setDataCadastro] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Verifica navegação e bloqueio ao sair da página
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const hasQuantity = Object.values(order).some(
        (item) => Number(item?.quantity) > 0 || item?.naoContado
      );

      if (hasQuantity) {
        event.preventDefault();
        event.returnValue = ''; // necessário para exibir o alerta padrão do navegador
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [order]);

  // Navega para a página inicial se usuário não estiver logado
  useEffect(() => {
    // Verifica se `userInfo` está vazio e força o redirecionamento
    if (!userInfo?.username || !userInfo?.company) {
      // Limpa qualquer dado residual do estado (se necessário)
      localStorage.removeItem('userInfo'); // Limpeza do localStorage, caso aplicável
      navigate('/home'); // Redireciona para a tela inicial (Home)
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${userInfo.url}/departamentoestoq/fornecedor/${userInfo.dpc_id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias
          },
        });
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error('Erro ao buscar produtos:', error);
      }
    };
  
    fetchProducts(); // Garantir que o fetch seja chamado no momento correto
  }, [userInfo]);
  
const incrementQuantity = (productId) => {
  setOrder((prev) => ({
    ...prev,
    [productId]: {
      ...prev[productId],
      quantity: (prev[productId]?.quantity || 0) + 1,
      naoContado: prev[productId]?.naoContado || false,
    }
  }));
};

const decrementQuantity = (productId) => {
  setOrder((prev) => ({
    ...prev,
    [productId]: {
      ...prev[productId],
      quantity: Math.max((prev[productId]?.quantity || 0) - 1, 0),
      naoContado: prev[productId]?.naoContado || false,
    }
  }));
};

const handleQuantityChange = (productId, value) => {
  const parsed = parseInt(value, 10);
  setOrder((prev) => ({
    ...prev,
    [productId]: {
      ...prev[productId],
      quantity: isNaN(parsed) ? '' : Math.max(parsed, 0),
      naoContado: prev[productId]?.naoContado || false,
    }
  }));
};

const toggleNaoContado = (productId, isChecked) => {
  setOrder((prev) => ({
    ...prev,
    [productId]: {
      ...prev[productId],
      naoContado: isChecked,
      quantity: isChecked ? null : 0,
    }
  }));
};

const confirmOrder = () => {
  if (!dataCadastro) {
    alert('Por favor, selecione a data da contagem.');
    return;
  }

  const dataSelecionada = new Date(dataCadastro);
  const dataMinima = new Date(getMinDate());
  const dataMaxima = new Date(getMaxDate());

  if (dataSelecionada < dataMinima || dataSelecionada > dataMaxima) {
    alert('A data informada está fora do intervalo permitido.');
    return;
  }

  const hasInvalidItem = products.some((product) => {
    const item = order[product.id];

    if (!item) return true;

    const quantidadePreenchida = item.quantity !== undefined && item.quantity !== '';
    const marcadoSemContagem = item.naoContado === true;

    return !quantidadePreenchida && !marcadoSemContagem;
  });

  if (hasInvalidItem) {
    alert('É OBRIGATÓRIO alimentar a quantidade com algum valor ou marcar "SEM CONTAGEM". Verifique todos os itens.');
    return;
  }

  const newOrderArray = Object.entries(order)
    .map(([productId, info]) => {
      const product = products.find((p) => p.id === parseInt(productId, 10));
      if (!product) return null;

      const quantity = info.quantity || 0;
      const volume = product.volume || 1;
      const total = info.naoContado ? null : quantity * volume;

      return {
        name: product.name,
        PRO_ID: product.id,
        DPES_QTD_PRODUTO: total,
        DPES_DESCRICAO: info.naoContado ? 'SEM CONTAGEM' : '',
        FOR_ID: userInfo.dpc_id,
        VEN_ID: userInfo.id,
        DPES_DTA_CADASTRO: dataCadastro,
        volume: volume, // usado no modal para exibir o volume
        IALM_QTD: quantity, // quantidade pura informada
        embUnidade: product.embUnidade, // unidade para exibir no modal
      };
    })
    .filter(item =>
      item &&
      (item.DPES_QTD_PRODUTO !== null || item.DPES_DESCRICAO === 'SEM CONTAGEM')
    );

  if (newOrderArray.length === 0) {
    alert('Todos os itens estão com quantidade zero e não foram marcados como "não contado".');
    return;
  }

  setOrderArray(newOrderArray);
  setShowModal(true);
  };

  const sendOrderToAPI = async () => {
    if (isSubmitting) return; // Evita múltiplos envios
    setIsSubmitting(true);

    try {
      const payload = orderArray;
      await validateUserAndSendOrder(payload);
    } catch (error) {
      console.error('Erro ao processar envio do pedido:', error);
    } finally {
      setIsSubmitting(false); // Libera novamente após conclusão
    }
  };
  
  const validateUserAndSendOrder = async (payload) => {
    try {
      // Passo 1: Verificar se o usuário é válido
      const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);
  
      const response = await fetch(`${userInfo.url}/login/v1`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`, // Insere o cabeçalho Authorization
        },
      });
  
      if (!response.ok) {
        /*console.error('Erro ao validar usuário:', response.status);*/
        alert('Usuário inválido! Operação cancelada.');
        return;
      }
  
      const data = await response.json();
  
      if (Array.isArray(data) && data.length > 0 && data[0].login === "Login realizado com sucesso!") {
        /*console.log('Usuário válido:', data);*/
  
        // Passo 2: Se válido, prosseguir para o POST
        const postResponse = await fetch(`${userInfo.url}/departamentoestoq/lista`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
          },
          body: JSON.stringify(payload), // Envia o payload como JSON
        });
  
        if (postResponse.ok) {
          /*const pdc_id = await postResponse.json();
          console.log('Inseridos itens na OP:', pdc_id);*/
          
          // Chamar a função para envio de e-mail
          await sendEmail(payload);

          alert('Pedido enviado com sucesso!');
          navigate('/menu'); // Redireciona após o envio
        } else {
          console.error('Erro no POST:', postResponse.status);
          alert('Erro ao realizar o POST.');
        }
      } else {
        console.error('Login inválido:', data);
        alert('Usuário inválido! Operação cancelada.');
      }
    } catch (error) {
      console.error('Erro ao validar usuário ou enviar pedido:', error);
      alert('Ocorreu um erro inesperado. Tente novamente.');
    }finally {
    setIsSubmitting(false);
  }
  };
  
  const sendEmail = async (payload) => {
    try {
      const emailPayload = {
        empresa: userInfo.company,
        usuario: userInfo.username,
        item_contagem: payload,
      };

      const emailResponse = await fetch(userInfo.urlEmail, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(emailPayload),
      });

      if (emailResponse.ok) {
        console.log('E-mail enviado com sucesso!');
      } else {
        console.error('Erro ao enviar e-mail:', emailResponse.status);
      }
    } catch (error) {
      console.error('Erro no envio do e-mail:', error);
    }
  };
  
  const increaseQuantity = (index) => {
    const updatedOrderArray = [...orderArray];
    updatedOrderArray[index].DPES_QTD_PRODUTO += 1;
    setOrderArray(updatedOrderArray);
  };
  
  const decreaseQuantity = (index) => {
    const updatedOrderArray = [...orderArray];
    if (updatedOrderArray[index].DPES_QTD_PRODUTO > 0) {
      updatedOrderArray[index].DPES_QTD_PRODUTO -= 1;
      setOrderArray(updatedOrderArray); 
    }
  };

  const getMaxDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
  };

  const getMinDate = () => {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 7);
    return minDate.toISOString().split('T')[0];
  };

const getUnidadeFormatada = (embUnidade) => {
  if (!embUnidade) return 'Un';

  const unidade = embUnidade.trim().toLowerCase();

  if (unidade === 'sc') return 'KG';
  if (unidade === 'gl') return 'LT';
  if (unidade === 'ga') return 'KG';
  if (unidade === 'bb') return 'KG';

  return embUnidade.toUpperCase(); // fallback
};

  return (
    <>
      <header className="header">
        <h2>Bem-vindo, {userInfo.username}!</h2>
        <h3>
          Empresa: {userInfo.dpc_id} - {userInfo.company}
        </h3>
        <h1>Lançamento de contagem de Estoque</h1>
      </header>

      <Link to="/menu" className="link-style">Voltar ao menu</Link>

      <div className='datacontagem'>
        <input
          id="data-contagem"
          type="date"
          value={dataCadastro}
          min={getMinDate()} // Limite inferior = hoje - 7 dias
          max={getMaxDate()} // Limite superior = hoje
          onChange={(e) => setDataCadastro(e.target.value)}
          onKeyDown={(e) => e.preventDefault()} // <--- Impede digitação manual
          required
        />
      </div>

      <div className="container-estoque">
        <div className="product-header">
          <span className="product-name-header">Produto</span>
          <span className="product-quantity-header">Qtd</span>
          <span className="product-checkbox-header">Sem Contagem</span>
        </div>
          <div id="product-list-estoque" style={{ display: products.length ? 'block' : 'none' }}>
            {products.map((product) => (
              <div key={product.id} className="product-item-estoque">
                <span><strong>{product.name}</strong></span>
                <div className="quantity-controls-estoque">
                  <button onClick={() => decrementQuantity(product.id)}>-</button>
                  <input
                    type="number"
                    value={order[product.id]?.quantity ?? ''}
                    onChange={(e) => handleQuantityChange(product.id, e.target.value)}
                    disabled={order[product.id]?.naoContado}
                  />
                  <span className='embalagem-alm'>{product.embUnidade}</span>
                  <button onClick={() => incrementQuantity(product.id)}>+</button>
                  <span className="total-volume-alm">
                    Total: {(order[product.id]?.quantity || 0) * (product.volume || 1)} {getUnidadeFormatada(product.embUnidade)}
                  </span>
                  <input
                    type="checkbox"
                    className="checkbox"
                    checked={order[product.id]?.naoContado || false}
                    onChange={(e) => toggleNaoContado(product.id, e.target.checked)}
                  />
                  </div>
              </div>
            ))}
          </div>
          <button id="send-order" onClick={confirmOrder} style={{ marginTop: '20px' }}>
            Ir para Conferência do Lançamento
          </button>
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>Confira os itens abaixo, para alterar clique em voltar.</h2>
            <ul className="order-list">
              {orderArray.map((item, index) => (
                <li key={index}>
                  <span className="item-name"><strong>{item.name}</strong></span>
                  <div className="item-quantity">
                    <button className='btnmenos' onClick={() => decreaseQuantity(index)}>-</button>
                    <input
                      className='qtdconfirm' disabled
                      type="number"
                      value={item.DPES_QTD_PRODUTO}
                      onChange={(e) => {
                        const newQuantity = Math.max(parseInt(e.target.value, 10) || 0, 0);
                        const updatedOrderArray = [...orderArray];
                        updatedOrderArray[index].DPES_QTD_PRODUTO = newQuantity;
                        setOrderArray(updatedOrderArray);
                      }}
                    /><br/>
                    {item.IALM_QTD > 0 ? (
                      <span className="total-volume">
                        Total: {item.volume > 0 ? (item.DPES_QTD_PRODUTO / item.volume).toFixed(2) : item.IALM_QTD} {item.embUnidade}
                      </span>
                    ) : (
                      <span className="total-volume">Não Contado</span>
                    )}
                    <button className='btnmais' onClick={() => increaseQuantity(index)}>+</button>
                  </div>
                </li>
              ))}
            </ul>

            <div className="modal-buttons">
              <button onClick={() => setShowModal(false)} className="closeModal">Voltar</button>
              <button
                onClick={sendOrderToAPI}
                className="sendOrder"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Enviando...' : 'Confirmar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Estoque;